module.exports = __webpack_public_path__ + "img/icon_1575.8b136de7.svg";